const InfoIconStyled = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
      <g clipPath="url(#clip0_571_18318)">
        <path
          d="M5.4 3.5H6.6V4.7H5.4V3.5ZM5.4 5.9H6.6V9.5H5.4V5.9ZM6 0.5C2.688 0.5 0 3.188 0 6.5C0 9.812 2.688 12.5 6 12.5C9.312 12.5 12 9.812 12 6.5C12 3.188 9.312 0.5 6 0.5ZM6 11.3C3.354 11.3 1.2 9.146 1.2 6.5C1.2 3.854 3.354 1.7 6 1.7C8.646 1.7 10.8 3.854 10.8 6.5C10.8 9.146 8.646 11.3 6 11.3Z"
          fill="#7B858B"
        />
      </g>
      <defs>
        <clipPath id="clip0_571_18318">
          <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InfoIconStyled;
